import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";
import CompanyDetailsModel from "../../models/masters/companydetails-model";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/CompanyDetails/GetAllCompanyDetails";// //{/api/Block/GetAllBlock}`)  //// "https://localhost:7054/api/Block/GetAllBlock";
export const useGetCompanyDetails = createQuery<
CompanyDetailsModel[],
  null,
  AxiosError
>({
  queryKey: ["keyCompanyDetailslist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
